// Single source of truth for legacy → canonical role translation.
//
// The 4-role canon is: admin | user | scanner | super-admin.
// Older DB records and unrefreshed auth claims may still carry pre-migration
// role strings (employer/recruiter/employee). This module normalises them.
// The backend setCompanyClaim CF should be doing the same translation
// server-side; this client-side map is defense-in-depth so a stale record
// never breaks navigation.
//
// Canonical-role resolution decides which entire app a user sees, so the
// behavior here is unified across web and mobile. Unknown/missing roles fall
// back to 'user' (the least-privileged field-worker view) — never to an
// admin surface.
export const LEGACY_ROLE_MAP = {
  employer:  'admin',
  recruiter: 'admin',
  employee:  'user',
};

/**
 * canonicalRole — translate a raw role string to the canonical role.
 *
 * - A known legacy role (employer/recruiter/employee) maps to its canon.
 * - A known canonical role (admin/user/scanner/super-admin) passes through.
 * - An unknown, undefined, null, or empty role falls back to 'user'.
 *
 * @param {string|null|undefined} rawRole
 * @returns {string} canonical role
 */
export function canonicalRole(rawRole) {
  return LEGACY_ROLE_MAP[rawRole] ?? rawRole ?? 'user';
}
